let isOpen = false;

const filterElem = document.querySelector('.js-filter');
const toggleElem = document.querySelector('.js-filter-toggle');
const optionElem = document.querySelector('.js-filter-options');

if (optionElem && toggleElem) {
	isOpen = toggleElem.dataset.hasOwnProperty('expanded');
	toggleElem.removeAttribute('data-expanded');

	setAriaAttributes();
	toggleElem.addEventListener('click', toggle);
	toggleElem.setAttribute('aria-controls', optionElem.id);
}

function open() {
	isOpen = true;

	optionElem.classList.add('is-open');
	filterElem.classList.add('is-open');
	toggleElem.textContent = 'Hide filters';

	setAriaAttributes();
}

function close() {
	isOpen = false;

	optionElem.classList.remove('is-open');
	filterElem.classList.remove('is-open');
	toggleElem.textContent = 'Show filters';

	setAriaAttributes();
}

function toggle() {
	isOpen ? close() : open();
}

function setAriaAttributes() {
	toggleElem.setAttribute('aria-expanded', isOpen);
}
